import { Spinner } from 'components/ui';
import React, { lazy, Suspense } from 'react';

const SeismicUniversalUploader = lazy(() =>
  import(/* webpackChunkName: "UUC" */ './Uploader'),
);

const Loader = () => (
  <div className="mt-16 ta-c">
    <Spinner size="larger" />
  </div>
);

// temporarily used to lo lazy load the uploader component since there's an outstanding issue lazy loading @seismic/universal-upload-component directly
const UniversalUploader = ({ accept, onComplete, onFileError }) => {
  return (
    <Suspense fallback={<Loader />}>
      <SeismicUniversalUploader
        accept={accept}
        onComplete={onComplete}
        onFileError={onFileError}
      />
    </Suspense>
  );
};

export { UniversalUploader };
